import { render, staticRenderFns } from "./EditPengirimanModal.vue?vue&type=template&id=c21b4aae&scoped=true"
import script from "./EditPengirimanModal.vue?vue&type=script&lang=js"
export * from "./EditPengirimanModal.vue?vue&type=script&lang=js"
import style0 from "./EditPengirimanModal.vue?vue&type=style&index=0&id=c21b4aae&prod&scoped=true&lang=css"
import style1 from "./EditPengirimanModal.vue?vue&type=style&index=1&id=c21b4aae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21b4aae",
  null
  
)

export default component.exports